<template>
	<RouterView />
</template>

<script>
import { useHead } from '@unhead/vue'

export default {
	name: 'App',
	setup() {
		useHead({
			titleTemplate: '%s | DTCC 2024 Annual Report',
			script: [
				{
					innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-59Q7PV');`
				}
			]
		})
	},
}
</script>

<style lang="scss">
@use 'styles/partials.scss';

#app {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	width: 100vw;
}
</style>
